"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = exports.initTranslationsWithStaticTranslations = exports.initTranslationsWithInitialTranslationsAndConfig = exports.initSelfConfigWebAndOwnTranslations = exports.initConfigWebAndOwnTranslations = exports.initConfigAndTranslations = exports.initBasicTranslations = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const helper_1 = require("./helper");
const initBasicTranslations = async (api, params) => {
    const translations = await (0, helper_1.getTranslations)(api, params);
    const entries = translations?.entries ? translations.entries : {};
    const constructorParams = {
        translations: entries,
        resolvers: [new web_ui_framework_1.PrimitiveResolver(entries)],
        config: {
            onMissingMessage: ({ key }) => {
                web_ui_framework_1.Log.error(`missing translations for key ${key}`);
                return params.staticTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return {
        translator,
        translations,
        configTranslations: undefined,
    };
};
exports.initBasicTranslations = initBasicTranslations;
const initConfigAndTranslations = async (api, params) => {
    const configAndTranslations = await (0, helper_1.getConfigAndTranslations)(api, params);
    const translations = configAndTranslations.translations;
    const configTranslations = configAndTranslations.configTranslations;
    const constructorParams = {
        translations: translations.entries,
        resolvers: [new web_ui_framework_1.PrimitiveResolver(configTranslations.entries)],
        config: {
            // eslint-disable-next-line no-console
            onMissingMessage: ({ key }) => {
                web_ui_framework_1.Log.error(`missing translations for key ${key}`);
                return params.staticTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return {
        translator,
        translations,
        configTranslations,
    };
};
exports.initConfigAndTranslations = initConfigAndTranslations;
const initConfigWebAndOwnTranslations = async (api, params) => {
    const configAndTranslations = await (0, helper_1.getConfigWebAndTranslations)(api, params);
    const translations = configAndTranslations.translations;
    const configTranslations = configAndTranslations.configTranslations;
    const webTranslations = configAndTranslations.webTranslations;
    const constructorParams = {
        translations: {
            ...webTranslations?.entries,
            ...translations.entries,
        },
        resolvers: [new web_ui_framework_1.PrimitiveResolver(configTranslations.entries)],
        config: {
            // eslint-disable-next-line no-console
            onMissingMessage: ({ key }) => {
                web_ui_framework_1.Log.error(`missing translations for key ${key}`);
                return params.staticTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return {
        translator,
        translations,
        configTranslations,
    };
};
exports.initConfigWebAndOwnTranslations = initConfigWebAndOwnTranslations;
const initSelfConfigWebAndOwnTranslations = async (api, params) => {
    const configAndTranslations = await (0, helper_1.getConfigWebAndTranslations)(api, params);
    const { translations, configTranslations } = configAndTranslations;
    const webTranslations = configAndTranslations.webTranslations;
    const constructorParams = {
        translations: {
            ...webTranslations?.entries,
            ...translations.entries,
        },
        resolvers: [new web_ui_framework_1.PrimitiveResolver(configTranslations.entries)],
        config: {
            // eslint-disable-next-line no-console
            onMissingMessage: ({ key }) => {
                web_ui_framework_1.Log.error(`missing translations for key ${key}`);
                return params.staticTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return { translations, translator, configTranslations };
};
exports.initSelfConfigWebAndOwnTranslations = initSelfConfigWebAndOwnTranslations;
const initTranslationsWithInitialTranslationsAndConfig = async (api, params, initialTranslations, newConfigTranslations) => {
    const translations = await (0, helper_1.getTranslations)(api, params);
    const entries = translations?.entries ? translations.entries : {};
    const newTranslations = {
        ...initialTranslations,
        ...entries,
    };
    const constructorParams = {
        translations: newTranslations,
        resolvers: [new web_ui_framework_1.PrimitiveResolver(newConfigTranslations)],
        config: {
            // eslint-disable-next-line no-console
            onMissingMessage: ({ key }) => {
                web_ui_framework_1.Log.error(`missing translations for key ${key}`);
                return params.staticTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return {
        translations,
        translator,
        configTranslations: undefined,
    };
};
exports.initTranslationsWithInitialTranslationsAndConfig = initTranslationsWithInitialTranslationsAndConfig;
const initTranslationsWithStaticTranslations = async (initialTranslations, configTranslations) => {
    const constructorParams = {
        translations: initialTranslations,
        resolvers: [new web_ui_framework_1.PrimitiveResolver(configTranslations)],
        config: {
            // eslint-disable-next-line no-console
            onMissingMessage: ({ key }) => {
                console.error(`missing translations for key "${key}"`);
                return initialTranslations?.[key] ?? key;
            },
        },
    };
    const translator = new web_ui_framework_1.Translator(constructorParams);
    return {
        translator,
    };
};
exports.initTranslationsWithStaticTranslations = initTranslationsWithStaticTranslations;
//Move to framework
const translate = (translator, key, values) => {
    return helper_1.showKeys ? key : translator.resolvedMessage({ key }, values);
};
exports.translate = translate;
//# sourceMappingURL=translations.js.map